new Swiper(".custom-swiper-collection", {
  slidesPerView: 2.5, // 一度に表示する枚数
  spaceBetween: "3.287671233%",
  freeMode: true,

  breakpoints: {
    751: {
      slidesPerView: 5.5,
      slidesPerGroup: 6,
      spaceBetween: "0.4371584699%",
      freeMode: false,
      speed: 1000,
      // slidesPerGroupSkip: 8,
      navigation: {
        nextEl: ".custom-swiper-collection__next",
        prevEl: ".custom-swiper-collection__prev",
      },
    },
    992: {
      spaceBetween: "0.4371584699%",
      slidesPerView: 8.43,
      slidesPerGroup: 9,
      speed: 1000,
      navigation: {
        nextEl: ".custom-swiper-collection__next",
        prevEl: ".custom-swiper-collection__prev",
      },
    },
  },

  on: {
    init: function () {
      // 各スライドにindex番号と最後の要素にdata属性を付与
      const SLIDES_LENGTH = this.slides.length;

      this.slides.forEach(function (slide, index) {
        slide.dataset.swiperSlideIndex = index + 1;

        if (index + 1 === SLIDES_LENGTH) {
          slide.dataset.swiperSlideIsEnd = "true";
        }
      });
    },
  },
});

// 関連商品だけ10件しか表示できないので、PCのみ表示件数減らす。
new Swiper(".custom-swiper-collection.related-products-swiper", {
  slidesPerView: 2.5, // 一度に表示する枚数
  spaceBetween: "3.287671233%",
  freeMode: true,

  breakpoints: {
    751: {
      slidesPerView: 5.5,
      slidesPerGroup: 6,
      spaceBetween: "0.4371584699%",
      freeMode: false,
      speed: 1000,
      // slidesPerGroupSkip: 8,
      navigation: {
        nextEl: ".custom-swiper-collection__next",
        prevEl: ".custom-swiper-collection__prev",
      },
    },
    992: {
      spaceBetween: "0.4371584699%",
      slidesPerView: 6,
      slidesPerGroup: 6,
      speed: 1000,
      navigation: {
        nextEl: ".custom-swiper-collection__next",
        prevEl: ".custom-swiper-collection__prev",
      },
    },
  },

  on: {
    init: function () {
      // 各スライドにindex番号と最後の要素にdata属性を付与
      const SLIDES_LENGTH = this.slides.length;

      this.slides.forEach(function (slide, index) {
        slide.dataset.swiperSlideIndex = index + 1;

        if (index + 1 === SLIDES_LENGTH) {
          slide.dataset.swiperSlideIsEnd = "true";
        }
      });
    },
  },
});
